import styled from 'styled-components'
import { BREAKPOINTS } from '../../../../styles/constants'

export const SalonsSearchWrapper = styled.div`
	width: 100%;
	max-width: 100%;

	@media (min-width: ${BREAKPOINTS.md}) {
		max-width: 50%;
	}

	@media (min-width: ${BREAKPOINTS.lg}) {
		max-width: 382px;
	}
`
